import { render } from "./breadcrumbView.vue?vue&type=template&id=2acdbbe4&scoped=true"
import script from "./breadcrumbView.vue?vue&type=script&lang=js"
export * from "./breadcrumbView.vue?vue&type=script&lang=js"

import "./breadcrumbView.vue?vue&type=style&index=0&id=2acdbbe4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2acdbbe4"]])

export default __exports__